import Chip from '@material-ui/core/Chip'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import React, { useEffect, useState } from 'react'
import useFilterStore from '../../../../Store/filterStore'
import styles from '../../modal.module.css'
import customDeleteIconSvg from './images/square-xmark.svg'
import { useStyles } from './utils/materialUI'
import infoIcon from '../images/circle-info-regular-full.svg'
import Tooltip from '@material-ui/core/Tooltip'
import { makeStyles } from '@material-ui/core/styles'

const useTooltipStyles = makeStyles({
  tooltip: {
    display: 'inline-block',
    maxWidth: 500,
    width: 'auto',
    fontSize: '13px',
    padding: '8px',
    whiteSpace: 'normal',
    lineHeight: 1.4,
    textAlign: 'left',
    wordBreak: 'break-word'
  },
  arrow: {}
})

function County ({ setLocalFilters, setLocationChanged }) {
  const {
    allFilters: { county: initialCounties }
  } = useFilterStore()

  const customDeleteIcon = (
    <img
      src={customDeleteIconSvg}
      alt='delete'
      style={{ width: 11, height: 13 }}
    />
  )

  const classes = useStyles()
  const tooltipClasses = useTooltipStyles()
  const [selectedCounty, setSelectedCounty] = useState([])
  const [inputValue, setInputValue] = useState('')

  const commitSelection = newValue => {
    setLocationChanged(true)
    setSelectedCounty(newValue)
    setLocalFilters(prevFilters => ({
      ...prevFilters,
      county: newValue
    }))
  }

  useEffect(() => {
    setSelectedCounty(initialCounties)
  }, [initialCounties])

  return (
    <div className={styles.inputColumn}>
      <div className={styles.sectionTitleWithIcon}>
        <span className={styles.labelLocation}>County</span>
        <Tooltip
          title="Filter by the property's county."
          arrow
          placement='top'
          classes={{
            tooltip: tooltipClasses.tooltip,
            arrow: tooltipClasses.arrow
          }}
        >
          <img
            src={infoIcon}
            alt='County info'
            width={14}
            height={14}
            className={styles.infoIcon}
          />
        </Tooltip>
      </div>

      <Autocomplete
        style={{ padding: '0px', fontSize: '12px' }}
        freeSolo
        multiple
        open={false}
        id='prevent_autofill'
        closeIcon={false}
        popupIcon={false}
        value={selectedCounty}
        onChange={(_, newValue) => {
          commitSelection(newValue)
          setInputValue('')
        }}
        deleteIcon={customDeleteIcon}
        options={[]}
        getOptionSelected={(option, value) => option === value}
        getOptionLabel={option => option}
        inputValue={inputValue}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === 'input') {
            setInputValue(newInputValue)
          }
        }}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip
              label={option}
              {...getTagProps({ index })}
              deleteIcon={customDeleteIcon}
            />
          ))
        }
        classes={{ option: classes.option }}
        renderInput={params => (
          <TextField
            style={{ padding: '0px' }}
            placeholder='Text'
            autoComplete='off'
            variant='outlined'
            {...params}
            onBlur={() => {
              const trimmed = inputValue.trim()
              if (trimmed && !selectedCounty.includes(trimmed)) {
                commitSelection([...selectedCounty, trimmed])
              }
              setInputValue('')
            }}
            InputProps={{
              ...params.InputProps,
              classes: {
                root: classes.inputRoot,
                focused: classes.focused,
                notchedOutline: classes.notchedOutline
              }
            }}
          />
        )}
      />
    </div>
  )
}

export default County
